import type { CreateScheduleRequest, ScheduleDetail, ScheduleSummary } from "../../services/configuration/configuration.types";

export function getScheduleList(data: ScheduleSummary[] | Record<string, ScheduleSummary>): ScheduleSummary[] {
    return Array.isArray(data) ? data : Object.values(data);
}

export const getScheduleErrorMessage = (error: unknown, fallback: string): string =>
    error instanceof Error && error.message ? error.message : fallback;

export function mapScheduleToForm(schedule: ScheduleDetail) {
    return {
        name: schedule.name || "",
        description: schedule.description || "",
        isActive: schedule.isActive ?? true,
        timeSlots: schedule.timeSlots || [],
    };
}

export function validateTimeSlots(slots: CreateScheduleRequest["timeSlots"]) {
    const timePattern = /^([01]\d|2[0-3]):[0-5]\d:[0-5]\d$/;
    for (const slot of slots ?? []) {
        const day = Number(slot.dayOfWeek);
        if (!Number.isInteger(day) || day < 0 || day > 6) {
            throw new Error(`Invalid dayOfWeek: ${slot.dayOfWeek}. Expected 0(Sun)-6(Sat).`);
        }
        if (!timePattern.test(slot.startTime)) {
            throw new Error(`Invalid startTime for day ${slot.dayOfWeek}: ${slot.startTime}. Expected HH:MM:SS.`);
        }
        if (!timePattern.test(slot.endTime)) {
            throw new Error(`Invalid endTime for day ${slot.dayOfWeek}: ${slot.endTime}. Expected HH:MM:SS.`);
        }
        // Valid HH:MM:SS strings sort chronologically.
        if (slot.startTime >= slot.endTime) {
            throw new Error(`startTime must be before endTime for day ${slot.dayOfWeek}.`);
        }
    }
}

export function buildSchedulePayload(values: CreateScheduleRequest): CreateScheduleRequest {
    validateTimeSlots(values.timeSlots);
    return {
        name: values.name,
        isActive: values.isActive ?? true,
        description: (values.description ?? "").trim().replace(/[^A-Za-z0-9 .-]/g, ""),
        ...(values.timeSlots?.length ? {
            timeSlots: values.timeSlots.map(slot => ({
                dayOfWeek: Number(slot.dayOfWeek),
                startTime: slot.startTime,
                endTime: slot.endTime,
                isActive: slot.isActive ?? true,
            })),
        } : {}),
    };
}
